// AUTO-GENERATED by `pnpm release gen` from changelog/. Do not edit by hand.
// The web client's What's New: the newest release with a highlight for the web.
import type { WhatsNewSlide } from "./whatsNew";

/** The release the screen describes, or null when there has never been one. */
export const WHATS_NEW_RELEASE: string | null = "1.6.2";

/** Its highlights' pages, in order. */
export const WHATS_NEW_SLIDES: WhatsNewSlide[] = ["typography","newNoteStart"];
